/*
 * Denne filen inneholder konfigurasjon for filtre i applikasjonen.
 * Den definerer ulike filtere som kan brukes for å filtrere tidsserier basert på stasjoner, geografiske områder og andre kriterier.
 */

export default {
  filtersStationsFromOtherActors: [
    {
      fields: ["PARAMETERNAVN"],
      matchFields: ["stasjonParameter"],
    },
    {
      fields: ["Date_Start", "Date_Slutt"],
      matchFields: ["dt_min_start_time", "dt_max_end_time"],
    },
    {
      fields: ["VASSDRAGSNR"],
      matchFields: ["vassdragsOmradeNr"],
    },
    {
      fields: ["MOH"],
      matchFields: ["stasjonHoyde_moh"],
    },
  ],
  geographicFilterOptions: [
    "Ingen kartavgrensning",
    "Avgrens til kartutsnitt",
    "Avgrens med polygon",
    "Avgrens med buffer",
  ],
  filters: [
    {
      key: "generalFilters",
      prefix: "",
      icon: "ti-list",
      name: "Generelle egenskaper",
      open: true,
      filters: [
        {
          show: true,
          type: "checkboxgroup",
          name: "stasjonParameter",
          parameter: "stasjonParameter",
          title: "Måleparametere",
          values: [],
          group: true,
          optionsHelpText: [
            {
              name: "Vannstand",
              infoText:
                'I Seriekart leses vannstandsdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekt observert vannstand. Det er ikke utført korrigering for isoppstuving eller rekonstruksjon av manglende verdier. Vannstandsdata på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig <a href="./info_pdf.pdf">innsamlet tidsskritt</a>. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.  ',
            },
            {
              name: "Vannføring",
              infoText:
                'I Seriekart leses vannføringsdata fra Hydag-arkivet (arkiv for <a href="./info_pdf.pdf">døgnverdier</a>) i Hydra II databasen. Data på Hydag er justert for målefeil til å vise korrekte observerte data. I tillegg er det utført korrigering for isoppstuving og rekonstruksjon av manglende verdier. Vannføringsserier på Hydag skal derfor i høy grad være komplette, men kan inneholde korrigerte verdier. ',
            },
            {
              name: "Snøens vannekvivalent",
              infoText:
                "I Seriekart leses snøens vannekvivalent fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte observerte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.  ",
            },
            {
              name: "Vanntemperatur",
              infoText:
                "I Seriekart leses vanntemperaturdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte observerte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Det er mulig å søke etter både vanntemperaturdata fra innsjøer (vertikaldata) og elver (tidsserier), men bare mulig å eksportere sistnevnte. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.  ",
            },
            {
              name: "Grunnvannsnivå",
              infoText:
                "I Seriekart leses grunnvannsdata fra Hydag-arkivet (arkiv for døgnverdier) i Hydra II databasen. Data på Hydag er justert for målefeil til å vise korrekte observerte data. I tillegg er det i mange tilfeller utført rekonstruksjon av manglende verdier. Grunnvannsdata på Hydag skal derfor til en viss grad være komplette, men kan inneholde korrigerte verdier.",
            },
            {
              name: "Driftsvannføring",
              infoText:
                "I Seriekart leses driftsvannføringsdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Forbitapping",
              infoText:
                "I Seriekart leses forbitappingsdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Lufttemperatur",
              infoText:
                "I Seriekart fins lufttemperaturserier fra både NVE og andre aktører. <br/><br/>Serier fra NVE leses fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte observert lufttemperatur. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. <br/><br/>For beskrivelse av datakvalitet i lufttemperaturserier fra andre aktører bør det rettes henvendelse til datakilden (Meteorologisk institutt, Statens vegvesen, osv.). Nedlagte lufttemperaturserier fra andre aktører er ikke tilgjengelige i Seriekart.<br/><br/>Ved eksport fra Seriekart vil lufttemperaturdata inntil videre bli døgnaggregert.",
            },
            {
              name: "Markfuktighet",
              infoText:
                "I Seriekart leses markfuktighetsdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekt observert markfuktighet. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Eksport av markfuktighetsdata fra Seriekart er foreløpig ikke mulig. ",
            },
            {
              name: "Nedbør",
              infoText:
                "I Seriekart fins nedbørsdata fra både NVE og andre aktører. <br/><br/>Serier fra NVE leses fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte observerte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. <br/><br/>For beskrivelse av datakvalitet i nedbørsserier fra andre aktører bør det rettes henvendelse til datakilden (Meteorologisk institutt, Statens vegvesen, osv.). Nedlagte nedbørsserier fra andre aktører er ikke tilgjengelige i Seriekart.<br/><br/>Ved eksport fra Seriekart vil nedbørsdata inntil videre bli døgnaggregert.",
            },
            {
              name: "Overløp",
              infoText:
                "I Seriekart leses overløpsdata fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Pumping",
              infoText:
                "I Seriekart leses data for pumping fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Smeltevann & nedbør",
              infoText:
                "I Seriekart leses data for smeltevann & nedbør fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Snødybde",
              infoText:
                "I Seriekart fins data for snødybde fra både NVE og andre aktører. <br/><br/>Serier fra NVE leses fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. <br/><br/>For beskrivelse av datakvalitet i serier fra andre aktører bør det rettes henvendelse til datakilden (Meteorologisk institutt, Statens vegvesen, osv.). Nedlagte serier for snødybde fra andre aktører er ikke tilgjengelige i Seriekart.<br/><br/>Ved eksport fra Seriekart vil data for snødybde inntil videre bli døgnaggregert.",
            },
            {
              name: "Konsentrasjon suspendert min. materiale",
              infoText:
                "I Seriekart leses data for konsentrasjon supendert min. materiale fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
            {
              name: "Konsentrasjon organisk materiale",
              infoText:
                "I Seriekart leses data for konsentrasjon organisk materiale fra Hykval-arkivet (HYdrologiske KVALitetskontrollerte data) i Hydra II databasen. Data på Hykval er justert for målefeil til å vise korrekte verdier. Det er ikke utført rekonstruksjon av manglende verdier. Data på Hykval-arkivet kan derfor inneholde hull. Data er lagret med opprinnelig innsamlet tidsskritt. Ved eksport fra Seriekart vil data inntil videre bli døgnaggregert.",
            },
          ],
          mostRelevantOptions: [
            "Vannstand",
            "Vannføring",
            "Snøens vannekvivalent",
            "Vanntemperatur",
            "Grunnvannsnivå",
          ],
          fetch: "unique",
          description:
            "Velg en eller flere måleparametere som du ønsker å ta med i utvalget av tidsserier. Klikk på tannhjulikonet til høyre for å se avanserte innstillinger for dette filteret.",
        },
        {
          show: true,
          type: "multiselect",
          name: "observasjonsSted",
          parameter: "observasjonsSted",
          title: "Målested",
          group: true,
          mostRelevantOptions: [
            "Elv - naturlig profil",
            "Elv - kunstig profil",
            "Innsjø",
            "Punktsverm",
            "Snøstrekk",
            "Snøpute",
            "Fjord",
            "Magasin",
            "Utslippspunkt",
          ],
          mostRelevantOptionsSpecificForParameters: {
            Vannstand: [
              "Elv - naturlig profil",
              "Elv - kunstig profil",
              "Innsjø",
            ],
            Vannføring: [
              "Elv - naturlig profil",
              "Elv - kunstig profil",
              "Innsjø",
            ],
            "Snøens vannekvivalent": ["Punktsverm", "Snøstrekk", "Snøpute"],
            Vanntemperatur: [
              "Elv - naturlig profil",
              "Elv - kunstig profil",
              "Fjord",
              "Innsjø",
              "Magasin",
              "Utslippspunkt",
            ],
            Grunnvannsnivå: ["Grunnvannsrør", "Grunnvannsbrønn"],
          },
          values: [],
          fetch: "unique",
          description:
            "Velg målestedene som du ønsker å ta med i utvalget av tidsserier. Utvalget i denne listen er dynamisk ut fra valgte måleparameter. Klikk på tannhjulikonet til høyre for å se avanserte innstillinger for dette filteret.",
        },
        {
          show: true,
          value: [1950, 2018],
          type: "date",
          startParameter: "dt_min_start_time",
          endParameter: "dt_max_end_time",
          description:
            "Dette filteret lar deg filtrere tidsserier ut fra tidsrom (fra år - til år). Filteret har to moduser. I modusen 'Dekker deler av tidsrommet' vises alle tidsserier som har vært aktive i deler av det angitte tidsrommet. I modusen 'Dekker hele tidsrommet' vises alle tidsserier som har vært aktive i hele tidsrommet. Selv om tidsserier blir med i utvalget betyr det ikke at de er komplette innenfor angitt tidsrom.",
          title: "Tidsrom",
          options: {
            value: [1950, 2018],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 1950,
            max: 2018,
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          show: true,
          type: "multiselect",
          name: "stasjonType",
          skipQuotes: true,
          parameter: "stasjonType",
          title: "Stasjonstyper",
          values: [],
          fetch: "unique",
          customLabel: (element) => {
            let text;
            switch (element) {
              case 1:
                text = "Forvaltningsstasjon";
                break;
              case 2:
                text = "Konsesjonspålagt stasjon";
                break;
              case 3:
                text = "Privat, ikke pålagt";
                break;
              case 4:
                text = "Annen";
                break;
              case 5:
                text = "Fjellskred";
                break;
              default:
                text = "Ikke angitt";
            }
            return text;
          },
          description:
            "Velg en eller flere stasjonstyper som du ønsker å ta med i utvalget av tidsserier. Klikk på tannhjulikonet til høyre for å se avanserte innstillinger for dette filteret.",
        },
        {
          show: true,
          type: "multiselect",
          name: "vassdragsomradenr",
          parameter: "vassdragsomradenr",
          title: "Vassdragsområder",
          useLikeOperator: true,
          likeOperatorPrefix: "%",
          likeOperatorPostfix: "%",
          filterProperty: "vassdragsomradenr",
          values: [],
          fetch: "unique",
          description:
            "Velg ett eller flere vassdragsområder som du ønsker å ta med i utvalget av tidsserier. Klikk på tannhjulikonet til høyre for å se avanserte innstillinger for dette filteret.",
          fetchUrl:
            "https://kart.nve.no/enterprise/rest/services/Nedborfelt2/MapServer/0",
          fetchParameter: "vassdragsomradenr",
          fetchOutfields: "vassdragsomradenr, vassdragsomradenavn",
          orderByField: "vassdragsomradenr",
          label: "vassdragsomradenavn",
          customLabel: (element) => {
            return element.vassdragsomradenr + " " + element.vassdragsomradenavn;
          },
        },
      ],
    },
    {
      key: "timeFilters",

      name: "Datakvalitet",
      showCheckbox: false,
      open: true,
      prefix: "",
      filters: [
        {
          name: "dataKvalitet",
          show: true,
          parameter: "compoundKey20",
          notAvailableText:
            "Filter for datakvalitet er kun tilgjengelig når du har valgt måleparameteret vannføring og valgt et tidsrom (fra år - til år) med filtermodus 'dekker hele tidsrommet' aktivert.",
          type: "dataquality",
          title: "Datakvalitet",
          values: [],
          description:
            "Her kan du filtrere tidsserier for vannføring basert på kompletthet og andel korrigerte data.",
          correctedDataFilterDescription:
            "Korrigerte data = vannføringsdata som er estimert fra iskorreksjon, rekonstruksjon eller lignende. Statistikk foreløpig bare gjeldende for vannføringsdata på HYDAG.",
          missingDataFilterDescription:
            "Statistikk foreløpig bare gjeldende for vannføringsdata på HYDAG.",
        },
      ],
    },
    {
      key: "gisFilters",
      group: {
        title: "Feltegenskaper",
        conditionalProp: "feltEgenskaperIsActive",
        disabledText:
          "Filter for feltegenskaper er kun tilgjengelig når måleparameterene vannføring og/eller vannstand er valgt.",
        enabledText:
          "Filtrer tidsserier basert på egenskapene til nedbørfeltet tidsseriene ligger i.",
        open: false,
      },
      name: "Feltegenskaper",
      showCheckbox: true,
      open: false,
      filters: [
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "gradient_10_85",
          title: "Bratthet",
          fetch: "minmax",
          description:
            "1085-gradient. Definert som elvegradienten, men de nederste 10% og de øverste 15% av elva regnes ikke med (m/km).",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            interval: 1,
            formatter: "{value}",
            unit: "",
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_breareal",
          title: "Breprosent ",
          percent: true,
          fetch: "minmax",
          description: "Prosentandel av nedbørsfeltet som består av bre.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "effektiv_sjoprosent",
          title: "Effektiv sjøprosent",
          fetch: "minmax",
          description:
            "Summen av produktene av innsjøenes overflateareal og deres tilsigsareal multiplisert med 100 og dividert med kvadratet av feltarealet.",
          percent: true,
          indicatorOptions: {},
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            interval: 1,
            formatter: "{value} %",
            unit: "%",
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "elvegradient",
          title: "Elvegradient",
          fetch: "minmax",
          description:
            "Total høydeforskjell langs hovedelva dividert med hovedelvas lengde (m/km).",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value}",
            unit: "",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          show: true,
          value: [0, 100],
          type: "rangeslider",
          startParameter: "totalt_feltareal_km2",
          title: "Feltareal",
          fetch: "minmax",
          description:
            "Areal av det naturlige nedbørsfeltet (regulering ikke inkludert) som drenerer til målestasjonen.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} km²",
            unit: "km²",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          show: true,
          value: [0, 100],
          type: "rangeslider",
          startParameter: "feltaksenslengde",
          title: "Feltlengde",
          fetch: "minmax",
          description:
            "Avstanden fra utløpet til det fjerneste punktet på vannskillet.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} m",
            unit: "m",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_innsjoareal",
          title: "Innsjøprosent ",
          percent: true,
          fetch: "minmax",
          description: "Prosentandel av nedbørsfeltet som består av innsjø.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_jordbruksareal",
          title: "Jordbruksprosent",
          fetch: "minmax",
          percent: true,
          description: "Prosentandel av nedbørsfeltet som består av jordbruk.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "hoyde_50persentil",
          title: "Medianhøyde",
          fetch: "minmax",
          description:
            "Medianhøyde av nedbørsfeltet som drenerer til målestasjonen.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} m",
            unit: "m",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_myrareal",
          title: "Myrprosent",
          fetch: "minmax",
          percent: true,
          description: "Prosentandel av nedbørsfeltet som består av myr.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "reguleringsgradAreal",
          title: "Reguleringsgrad areal",
          fetch: "minmax",
          description:
            "Forholdet mellom totalt reguleringsareal og beregningspunktets naturlige felt. Reguleringsareal beregnes som sum areal oppstrøms et beregningspunkt som drenerer til et magasin eller et bekkeinntak/ overføring.",
          options: {
            value: [0, 1],
            decimals: true,
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 1,
            interval: 0.1,
            formatter: "{value}",
            unit: "",
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "reguleringsgradMagasin",
          title: "Reguleringsgrad mag.",
          fetch: "minmax",
          description:
            "Forholdet mellom summen av volumene mellom HRV og LRV for alle reguleringsmagasin i beregningspunktets naturlige nedbørfelt, og normalavløpet i feltet i perioden 1961-1990.",
          options: {
            value: [0, 1],
            decimals: true,
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 1,
            interval: 0.1,
            formatter: "{value}",
            unit: "",
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_skogareal",
          title: "Skogprosent",
          fetch: "minmax",
          percent: true,
          description: "Prosentandel av nedbørsfeltet som består av skog.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_snaufjell",
          title: "Snaufjellsprosent",
          percent: true,
          fetch: "minmax",
          description: "Prosentandel av nedbørsfeltet som består av snaufjell.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
        {
          value: [0, 100],
          show: true,
          type: "rangeslider",
          startParameter: "andel_urbantareal",
          title: "Urbantareal prosent",
          fetch: "minmax",
          percent: true,
          description:
            "Prosentandel av nedbørsfeltet som består av urbant areal.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} %",
            unit: "%",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
      ],
    },
    {
      key: "avrenningFilters",
      name: "Avrenningsstatistikk",
      showCheckbox: true,
      open: false,
      prefix: "",
      filters: [
        {
          value: [0, 100],
          showCheckbox: true,
          show: true,
          isFeltEgenskap: false,
          type: "rangeslider",
          startParameter: "normalAvrenningLsKm",
          title: "Normal årsavrenning",
          fetch: "minmax",
          description:
            "Normal årsavrenning for vannføringsserien. Gjennomsnitt over 30 år (1991-2020) beregnet fra avrenningskart.",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            formatter: "{value} l/s km2",
            unit: "l/s km2",
            interval: 1,
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },
      ],
    },
    {
      key: "stationFilters",
      prefix: "",
      icon: "ti-list",
      name: "Stasjonsegenskaper",
      open: true,
      filters: [
        {
          value: [0, 100],
          show: true,
          showCheckbox: true,
          filterActive: false,

          isFeltEgenskap: false,
          type: "rangeslider",
          startParameter: "stasjonHoyde_moh",
          title: "Høyde over havet",
          description:
            "Filtrer tidsserier basert på stasjonens høyde over havet.",
          fetch: "minmax",
          options: {
            value: [0, 100],
            width: 305,
            height: 8,
            dotSize: 20,
            min: 0,
            max: 100,
            interval: 1,
            formatter: "{value} moh",
            unit: "moh",
            disabled: false,
            show: true,
            speed: 0.3,
            reverse: false,
            lazy: true,
            tooltip: "always",
            piecewise: false,
          },
        },

        {
          show: true,
          type: "checkbox",
          name: "sanntid",
          parameter: "sanntid",
          title: "Skjul serier uten sanntidsmåling",
          description:
            "Huk av denne sjekkboksen hvis du ønsker å kun vise tidsserier som er registrert i sanntid.",
          checked: "J",
          operator: "=",
          stringCheck: true,
          value: false,
        },
        {
          show: true,
          type: "checkbox",
          name: "status",
          parameter: "status",
          title: "Skjul serier fra nedlagte stasjoner",
          description:
            "Huk av denne sjekkboksen hvis du ønsker å skjule serier fra nedlagte stasjoner.",
          checked: "D",
          operator: "=",
          stringCheck: true,
          value: false,
        },
      ],
    },
  ],
};
